import { useExperiment as useOptimizelyExperiment } from '@optimizely/react-sdk';
import { Experiments, ExperimentVariantsValues } from 'app/types/optimizely';

interface UseExperimentOptions {
  autoUpdate?: boolean;
  timeout?: number;
}

interface UseExperimentOverrides {
  overrideUserId?: string;
  overrideAttributes?: Record<string, any>;
}

export const useExperiment = <E extends Experiments>(
  experimentName: E,
  options?: UseExperimentOptions,
  overrides?: UseExperimentOverrides
) =>
  useOptimizelyExperiment(experimentName, options, overrides) as [ExperimentVariantsValues<E> | null, boolean, boolean];
